import { FC, useContext, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useUserSettings } from "../../context/userSettingsContext";
import useDataInitializer from "../../hooks/useDataInitializer";
import { useI18n } from "../../hooks/useTranslations";
import { useCarPlanningsApi } from "../../http/carPlannings/api";
import Header from "../ui/Header";
import Panel from "../ui/Panel";
import CarPlanningForm, { CarPlanningFormBody } from "./CarPlanningForm";

const EditCarPlanning: FC = () => {
  const i18n = useI18n();
  const carPlanningsApi = useCarPlanningsApi();
  const userSettings = useUserSettings();
  const dispatch = useContext(NotificationDispatch);
  const { id } = useParams<{ id: string }>();
  const aborter = useRef(new AbortController());
  const [isSubmitting, setIsSubmitting] = useState(false);

  const carPlanningSwr = carPlanningsApi.getAdminCarPlanning(id!, aborter.current.signal);
  const [carPlanning, isInitialized] = useDataInitializer(carPlanningSwr.data, carPlanningSwr.error);

  useEffect(() => {
    id && carPlanningSwr.trigger();
  }, [id]);

  useEffect(() => {
    carPlanningSwr.error && dispatch(showErrorNotification(i18n, carPlanningSwr.error));
  }, [carPlanningSwr.error]);

  const onSubmit = async (dataForm: CarPlanningFormBody) => {
    if (carPlanning?.id) {
      setIsSubmitting(true);
      try {
        await carPlanningsApi.updateAdminCarPlanning(id!, {
          year: dataForm.year,
          nr: dataForm.nr,
          driverName: dataForm.driverName,
          managerName: dataForm.managerName,
          costCenter: dataForm.costCenter,
          startDate: dataForm.startDate,
          carArrivalDate: dataForm.carArrivalDate,
          subsidiaryId: dataForm.subsidiary.id,
          status: dataForm.state?.value,
          type: dataForm.type?.value,
          priceWithoutVat: dataForm.priceWithoutVat,
          currentVersionNumber: carPlanning.versionNumber!,
        });
        dispatch(showSuccessNotification(i18n.t));
        carPlanningSwr.trigger();
      } catch (error) {
        dispatch(showErrorNotification(i18n, error));
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  return (
    <>
      <Header title={i18n.t.carPlannings.edit} />
      <Panel>
        <CarPlanningForm
          onSubmit={onSubmit}
          carPlanning={carPlanning}
          isDisabled={!carPlanning?.id || isSubmitting || !userSettings.permissions.carPlannings.update}
          isLoading={!isInitialized}
          // onUpdate={() => carPlanningSwr.trigger()}
        />
      </Panel>
    </>
  );
};

export default EditCarPlanning;
